import {IFirebaseTopicRegistration} from "../firebase-topic-view-model.interface";
import {IMessagesTopicEventsViewModel, IMessagesTopicEventViewModel} from "./messages-topic.view-model.interface";
import {OmgEventData} from "./publish-data/omg.event-data";
import {KickEventData} from "./publish-data/kick.event-data";
import {PeriodicGeoEventData} from "./publish-data/periodic-geo.event-data";
import {GeoRestrictionsUpdateEventData} from "./publish-data/geo-restrictions-update.event-data";
import {BonusAbuseMoneyParkingEventData} from "./publish-data/bonus-abuse-money-parking.event-data";
import {PromotionChangedEventData} from "./publish-data/promotion-changed.event-data";
import {GamblingSessionActionEventData} from "./publish-data/gambling-session-action.event-data";
import {ToastEventData} from "./publish-data/toast.event-data";
import {IRawRestrictionType} from "./raw-data/restrictions-update.raw-data";


export class MessagesTopicEvents implements IMessagesTopicEventsViewModel {
    readonly omg: MessagesTopicEvent<OmgEventData> = new MessagesTopicEvent<OmgEventData>();
    readonly burnout: MessagesTopicEvent<void> = new MessagesTopicEvent<void>();
    readonly toast: MessagesTopicEvent<ToastEventData[]> = new MessagesTopicEvent<ToastEventData[]>();
    readonly kick: MessagesTopicEvent<KickEventData> = new MessagesTopicEvent<KickEventData>();
    readonly periodicGeo: MessagesTopicEvent<PeriodicGeoEventData> = new MessagesTopicEvent<PeriodicGeoEventData>();
    readonly restrictionsUpdate: MessagesTopicEvent<IRawRestrictionType[]> = new MessagesTopicEvent<IRawRestrictionType[]>();
    readonly geoRestrictionsUpdate: MessagesTopicEvent<GeoRestrictionsUpdateEventData> = new MessagesTopicEvent<GeoRestrictionsUpdateEventData>();
    readonly bonusAbuseParkingMoney: MessagesTopicEvent<BonusAbuseMoneyParkingEventData> = new MessagesTopicEvent<BonusAbuseMoneyParkingEventData>();
    readonly promotionChanged: MessagesTopicEvent<PromotionChangedEventData> = new MessagesTopicEvent<PromotionChangedEventData>();
    readonly gamblingSessionAction: MessagesTopicEvent<GamblingSessionActionEventData> = new MessagesTopicEvent<GamblingSessionActionEventData>();
}

export class MessagesTopicEvent<TEventData> implements IMessagesTopicEventViewModel<TEventData> {
    private _listeners: Array<(data: TEventData) => void> = [];

    registerListener(callback: (data: TEventData) => void): IFirebaseTopicRegistration {
        this._listeners.push(callback);
        return {
            unregister: () => {
                const index = this._listeners.indexOf(callback);
                if(index >= 0) {
                    this._listeners.splice(index, 1);
                }
            }
        };
    }

    notifyListeners(data: TEventData): void {
        for (const listener of this._listeners) {
            try {
                listener(data);
            }
            catch (error) {
                console.error(`Failed to notify firebase listener ${listener}`, error);
            }
        }
    }
}